module.exports = __webpack_public_path__ + "static/img/taxsaas_logo.2cf0491.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxsaas_logo.png
// module id = pHCV
// module chunks = 34